'use client';

import * as React from 'react';
import { ThemeProvider as NextThemeProvider } from 'next-themes';

/**
 * Drives the `.dark` class on <html> that the design-token system in
 * globals.css keys off. `system` by default so the app respects the OS,
 * with no transition flash on toggle.
 */
export function ThemeProvider({ children }: { children: React.ReactNode }) {
  return (
    <NextThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      {children}
    </NextThemeProvider>
  );
}
